import type { ICompany, IFile } from '@types'
import { FileTag, TimeFormat } from '@types'

export const DEFAULT_TIME_SETTINGS_STEP = 15

export function isFileLogo(file: IFile) {
  return file.tag === FileTag.LOGO
}

export function isFilePhoto(file: IFile) {
  return file.tag === FileTag.PHOTO
}

export function getLogoFile(company: ICompany) {
  return company.files?.find(isFileLogo)
}

export function getFilesWithoutLogo(company: ICompany) {
  return company.files?.filter(f => !isFileLogo(f)) || []
}

export function getPhotos(company: ICompany) {
  return company.files?.filter(isFilePhoto) || []
}

export function setPhotos(company: ICompany, photos: IFile[]) {
  const notPhotos = company.files?.filter(f => !isFilePhoto(f)) || []
  return (company.files = [...notPhotos, ...photos])
}

export function is12HourTimeFormat(company: ICompany) {
  return company?.settings?.timeFormat === TimeFormat.Hour12
}

export function getMinTimeStep(calendarTimeStep?: number) {
  if (!calendarTimeStep) {
    return DEFAULT_TIME_SETTINGS_STEP
  }

  return Math.min(calendarTimeStep, DEFAULT_TIME_SETTINGS_STEP)
}

export function getCalendarTimeStep(company?: Pick<ICompany, 'calendarTimeStep'>) {
  return company?.calendarTimeStep || DEFAULT_TIME_SETTINGS_STEP
}

export function getSlotsStep(company: ICompany, fixLength: number) {
  return fixLength || company.calendarTimeStep
}
